/**
 * Where focus goes once a suggestion leaves its section (TMMAPP-0143 item 2): the first action of
 * the row now at `index` (the next one, or the new last one), as `PayeeProposalList` does; once the
 * section has emptied (`section` is null), the page's `h1`. Never left on `<body>`.
 */
export function focusAfterRemoval(section: HTMLElement | null, index: number): void {
  const rows = section === null ? [] : Array.from(section.querySelectorAll('article'));
  if (rows.length > 0) {
    rows[Math.min(index, rows.length - 1)]?.querySelector<HTMLElement>('button')?.focus();
    return;
  }
  const title =
    document.getElementById('page-title') ?? document.querySelector<HTMLElement>('main h1');
  if (title === null) return;
  if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');
  title.focus();
}
